import React from 'react';
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
var DigitalTranslationStatus = function DigitalTranslationStatus(_ref) {
  var digitalTranslation = _ref.digitalTranslation;
  var iconStyle = {
    color: digitalTranslation.color
  };
  if (digitalTranslation.processing) {
    return /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: "fa-solid fa-circle-o-notch",
      spin: true
    });
  }
  return /*#__PURE__*/React.createElement(CircularProgressbarWithChildren, {
    value: 10,
    maxValue: 10,
    styles: buildStyles({
      pathColor: digitalTranslation.color,
      textColor: digitalTranslation.color
    })
  }, digitalTranslation.failed ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-times",
    style: iconStyle
  }) : null, digitalTranslation.processing ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-gears",
    style: iconStyle
  }) : null, digitalTranslation.completed ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-check",
    style: iconStyle
  }) : null);
};
export default DigitalTranslationStatus;